import React, { Component } from 'react'
import { without } from 'ramda'
import { Button, Icon, ToolTip } from '@driftt/tide-core-legacy'
import AddButton from '../AddButton/index'
import AttributeMappingRow from '../AttributeMappingRow/index'
import withNotifications from 'components/shared/notifications'
import cx from 'classnames'

import './style.styl'

const getSuccessMessage = (integrationName) => `You successfully updated your ${integrationName} App!`

class AttributeMapper extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editingIntegrationProperty: null,
      mappings: this.checkEmptyState(_.cloneDeep(props.mappings)),
      toDelete: [],
      overwriteHelpText: "Allow previously synced attributes to be overwritten by newer values in order to keep " + props.integrationName + " up to date."
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.allowAttributeDefaults && this.props.allowAttributeDefaults !== nextProps.allowAttributeDefaults){
      const updatedMappings = _.cloneDeep(nextProps.mappings.map(mapping => (mapping.driftAttribute && mapping.defaultValue) ? Object.assign(mapping, {defaultValue: null}) : mapping))
      this.setState({mappings: this.checkEmptyState(updatedMappings)})
    }
    else if (!_.isEqual(this.props.mappings, nextProps.mappings)) {
      this.setState({
        mappings: this.checkEmptyState(_.cloneDeep(nextProps.mappings))
      })
    }

    if (nextProps.patchError) {
      nextProps.patchError.json().then(resp => {
        resp.message && this.props.notifications.error(resp.message)
      })
    }
  }

  checkEmptyState = (mappings) => {
    const mappingsEmptyState = [{
      "integrationAttribute": null,
      "driftAttribute": null,
      "defaultValue": null,
      "isOverwritable": false,
      "editable": true
    }]

    return mappings.length > 0 ? mappings : mappingsEmptyState
  }

  isClean = () => {
    const validMappings = this.getValidMappings()
    return _.isEqual(validMappings, this.props.mappings)
  }

  isMappingValid(mapping) {
    return (!!mapping.driftAttribute || !!mapping.defaultValue) && !!mapping.integrationAttribute
  }

  getValidMappings = () => {
    return _.filter(this.state.mappings, (map) => {
      return this.isMappingValid(map)
    })
  }

  addNewMapping = () => {
    const updatedMappings = [...this.state.mappings]
    updatedMappings.push(Object.assign({}, this.props.mappingModel))

    this.setState({ mappings: this.checkEmptyState(updatedMappings) })
  }

  updateDeleteProperties = ({ target }) => {
    this.setState(prevState => {
      const { value, checked } = target
      const updatedToDelete = checked
        ? [...prevState.toDelete, value]
        : without(value, prevState.toDelete)

      return {
        toDelete: updatedToDelete
      }
    })
  }

  patchMappings = () => {
    const { integrationName, notifications, patchMappings } = this.props
    const successCB = () => notifications.success(getSuccessMessage(integrationName))
    const strippedMappings = this.getValidMappings()
    patchMappings(strippedMappings, successCB)
  }

  deleteMappings = () => {
    const updatedMappings = [...this.state.mappings]
    _.pullAt(updatedMappings, this.state.toDelete)

    this.setState({
      mappings: this.checkEmptyState(updatedMappings),
      toDelete: []
    }, this.patchMappings)
  }

  updateMapping = (index, mapping) => {
    const updatedMappings = [...this.state.mappings]
    updatedMappings[index] = mapping

    this.setState({ mappings: this.checkEmptyState(updatedMappings) })
  }

  renderTableRows() {
    const { driftAttributes, integrationAttributes, integrationName, allowAttributeDefaults, allowAttributeOverwrites } = this.props

    return this.state.mappings.map((mapItem, index) => {
      const matchedMapItem = _.find(integrationAttributes, { name: mapItem.integrationAttribute })
      // Skip type filter if the attribute is has_consent as its type was altered after it was introduced.
      const driftAttributesByType = (matchedMapItem && mapItem.driftAttribute !== 'has_consent') ? driftAttributes.filter(attr =>
        attr.type === matchedMapItem.type || (attr.type==="DATETIME" && matchedMapItem.type==="DATE")) : driftAttributes

      return <AttributeMappingRow
        mapping={mapItem}
        key={mapItem.integrationAttribute}
        index={index}
        integrationAttributes={integrationAttributes}
        driftAttributes={driftAttributesByType}
        defaultValue = {mapItem.defaultValue}
        updateDeleteProperties={this.updateDeleteProperties}
        updateMapping={this.updateMapping} 
        allowAttributeDefaults={allowAttributeDefaults}
        allowAttributeOverwrites={allowAttributeOverwrites}/>
    })
  }

  render() {
    const { patchLoading, integrationName, allowAttributeDefaults, allowAttributeOverwrites } = this.props
    const { toDelete, overwriteHelpText } = this.state
    return (
      <div>
        <div className="mapping-actions">
          {toDelete.length > 0 &&
            <div className="selected-delete">
              <span className="selected-text">{toDelete.length} Selected</span>
              <div className="selected-separator" style={{ padding: '0 .9rem' }}>
      
              </div>
              <div className="delete-button" onClick={this.deleteMappings} >
                <Icon className="delete-icon" width={15} name="trash"/>
                <span className="delete-text">Delete</span>
              </div>
            </div>
          }
          {toDelete.length === 0 &&
            <span><strong>*</strong>Required Fields</span>
          }
          <AddButton
          addButtonLabel="Add New Field"
          type="tertiary"
          className="mapping-add-field"
          onClick={this.addNewMapping}
          />
          <Button
            onClick={this.patchMappings}
            size="medium"
            loading={patchLoading}
            disabled={this.isClean() || !this.state.mappings.length}
          >
            Update
          </Button>
        </div>

        <table className="drift-table mapping-table drift-form">
          <thead>
            <tr>
              <th className="empty-header"></th>
              <th className={cx("drift-attribute-header", {"drift-attribute-header-expand": !allowAttributeDefaults})}>Drift Attribute or Value</th>
              {allowAttributeDefaults && <th className="drift-attribute-header">Default Value</th>}
              <th className="type-header"><span>Type</span></th>
              <th className={cx("field-header", {"field-header-expand": !allowAttributeDefaults})}>{integrationName} Field</th>
              { allowAttributeOverwrites != false &&
                <th className="overwrite-header">Allow overwrite?
                  <ToolTip flow="up" component={overwriteHelpText} className="overwrite-info-button">
                    <Icon width={15} height={15} name="info"/>
                  </ToolTip>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            {this.renderTableRows()}
          </tbody>
        </table>
      </div>
    )
  }
}

export default withNotifications(AttributeMapper)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/AttributeMapper/index.js